<template>
  <div class="mb-4" v-if="nrePage.nreData">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
        <b-badge style="margin-left: 13.5px;" v-if="$attrs.isETOSELECT" variant="primary">ETO Sector SKU</b-badge>
      </div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div><gtc-ftie :ftieId="basic_info_review.ftie_id" /></div>
          </div>
          <div class="header-col">
            <div>ETO NRE</div>
            <div>{{ basic_info_review.nre_id }}</div>
          </div>
          <div class="header-col">
            <div>Salesforce ES</div>
            <div>{{ basic_info_review.sales_force_es_no }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <gtc-opportunity :opportunityId="basic_info_review.sales_force_opty_id"
                             :opportunityName="basic_info_review.sales_force_opty" />
          </div>
          <div class="header-col">
            <div>Account Name</div>
            <div>{{ basic_info_review.account }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Product</div>
            <div>{{ basic_info_review.nre_model }}</div>
          </div>
          <div class="header-col">
            <div>Customization SKU ID</div>
            <div>{{ basic_info_review.sku_id }}</div>
          </div>
        </div>
      </div>
      <!--#endregion Header-->
    </div>
    <!--#endregion-->
    <!--#region Customization Proposal-->
    <div class="stage-header border-bottom mb-4">
      <div class="stage-body-customization-proposal">
        <div class="caption-label">Customization Proposal</div>
        <div>
          <gtc-froala :read-only="true" v-model="nre_estimation_from_espm.customization_proposal" />
        </div>
      </div>
      <div><br /><br /></div>
    </div>
    <!--#endregion: Customization Proposal-->

    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">NRE Estimation</div>
              <div>
                <div class="header-col">
                  <div>Module</div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="nre_estimation_from_espm.module" />
                  </div>
                </div>
                <div class="header-col">
                  <div>PoC Required</div>
                  <div>
                    {{ nre_estimation_from_espm.poc_required === 'Y' ? 'Yes' : 'No' }}
                  </div>
                </div>
                <!--#region Table-->
                <div class="mt-3">
                  <table class="table nre-estimation-table table-sm">
                    <colgroup>
                      <col style="width: 1px;" />
                      <col />
                      <col style="width: 6rem;" />
                      <col style="width: 6rem;" />
                      <col style="width: 8.9rem;" />
                      <col style="width: 8.9rem;" />
                    </colgroup>
                    <thead class="text-dark thead-light">
                      <tr>
                        <th rowspan="2" class="align-middle text-center">Category</th>
                        <th rowspan="2" class="align-middle text-center">Item</th>
                        <th colspan="2" class="text-center">ES PM</th>
                        <th colspan="2" class="text-center">HQ Sales</th>
                      </tr>
                      <tr>
                        <th class="text-center">{{ $attrs.pocWordingES }}</th>
                        <th class="text-center">{{ $attrs.mpWordingES }}</th>
                        <th class="text-center">{{ $attrs.pocWordingHQ }}</th>
                        <th class="text-center">{{ $attrs.mpWordingHQ }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!--#region Labor Cost-->
                      <tr>
                        <td rowspan="2">Labor Cost</td>
                        <td>Development</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.development.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.development.mp_cost" /></td>
                        <td rowspan="2"><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="laborCost.poc_cost" v-model="nre_estimation_curr_stage.labor_cost.poc_cost" /></td>
                        <td rowspan="2"><gtc-number percentage :read-only="$attrs.readOnly" :base="laborCost.mp_cost" v-model="nre_estimation_curr_stage.labor_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Verification</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.verification.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.verification.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Test Sample-->
                      <tr>
                        <td>Test Sample</td>
                        <td>EQT Test Sample</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.test_sample.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.test_sample.mp_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_from_espm.test_sample.poc_cost" v-model="nre_estimation_curr_stage.test_sample.poc_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_from_espm.test_sample.mp_cost" v-model="nre_estimation_curr_stage.test_sample.mp_cost" /></td>
                      </tr>

                      <!--#endregion-->
                      <!--#region Job Cost-->
                      <tr>
                        <td rowspan="5">Job Cost</td>
                        <td>Tooling Fee</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.tooling_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.tooling_fee.mp_cost" /></td>
                        <td rowspan="5"><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="jobCost.poc_cost" v-model="nre_estimation_curr_stage.job_cost.poc_cost" /></td>
                        <td rowspan="5"><gtc-number percentage :read-only="$attrs.readOnly" :base="jobCost.mp_cost" v-model="nre_estimation_curr_stage.job_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>PCB Fabrication Fee</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.pcb_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.pcb_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Test Jig / Fixture</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.test_jig.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.test_jig.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Outsource Fee</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.outsource_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.outsource_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.job_cost.job_cost_others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.job_cost_others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.job_cost_others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Regulation-->
                      <tr>
                        <td rowspan="4">Regulation</td>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">EMC - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.emc.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.emc.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.emc.mp_cost" /></td>
                        <td rowspan="4"><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="regulation.poc_cost" v-model="nre_estimation_curr_stage.regulation.regulation_others.poc_cost" /></td>
                        <td rowspan="4"><gtc-number percentage :read-only="$attrs.readOnly" :base="regulation.mp_cost" v-model="nre_estimation_curr_stage.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Safety - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.safety.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.safety.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.safety.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Environmental - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.environment.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.environment.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.environment.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.regulation_others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.regulation_others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Others-->
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.others.mp_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_from_espm.others.poc_cost" v-model="nre_estimation_curr_stage.others.poc_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_from_espm.others.mp_cost" v-model="nre_estimation_curr_stage.others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>Total NRE</td>
                        <td></td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost_curr_stage | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost_curr_stage | comma }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <!--#endregion-->
              </div>
            </div>
            <!--#endregion-->
          </div>
          <div class="col">
            <!--#region Project Proposal File-->
            <div class="stage-body-project-proposal-file mt-3">
              <div class="caption-label d-flex">
                <div>Project Proposal File</div>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark"
                         :items="proposal_files" :fields="nrePage.projectProposalFileSetting">
                  <template #cell(file_name)="data">
                    <a herf="#" class="file" @click="$emit('getFile',data.item)">{{data.item.file_name}}</a>
                  </template>
                  <template #cell(update_time)="data">
                    {{ data.item.update_time | dateTimeFormat }}
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
          </div>
        </div>
      </div>
      <!-- Region: Ref SKU Info -->
      <div class="stage-header border-bottom mb-4">
        <div class="caption-label">Reference(Standard) SKU Price Information</div>
        <div class="row mb-4">
          <div class="col-4">
            <div class="row">
              <div class="col-auto">
                <div class="header-col">
                  <div>Standard SKU ID</div>
                  <div>{{ _.get(skuItem, 'sku_id', '') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>HQ Cost</div>
              <div>{{ $attrs.currencySign}} {{ _.get(skuItem, 'price_info.hq_cost', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>GRO Cost</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.gro_cost', '') | comma }}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>Distributor Price</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.distributor_price', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>Reseller Price</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.reseller_price', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>MSRP</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.msrp', '') | comma }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion: ref sku info-->
      <!--#region Cost Per Unit Estimation-->
      <div class="stage-body-cost-per-unit-estimation border-bottom pb-4 mb-4">
        <div class="caption-label">Cost Per Unit Estimation</div>
        <div>
          <table class="table table-sm cost-per-unit-estimation-table">
            <colgroup>
              <col style="width:1px;" />
              <col style="width:6rem;" />
              <col style="width:6rem;" />
              <col style="width:8.9rem;" />
              <col style="width:8.9rem;" />
              <col />
            </colgroup>
            <thead class="text-dark thead-light">
              <tr>
                <th class="text-nowrap text-center align-middle" rowspan="2">Category</th>
                <th class="text-nowrap text-center align-middle" colspan="2">ES PM</th>
                <th class="text-nowrap text-center align-middle" colspan="2">HQ Sales</th>
                <th class="text-nowrap text-center align-middle" rowspan="2">Remark</th>
              </tr>
              <tr>
                <th class="text-nowrap text-center align-middle">{{ $attrs.pocWordingES }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.mpWordingES }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.pocWordingHQ }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.mpWordingHQ }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Demand Quantity</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_curr_stage.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_curr_stage.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_from_espm.demand_quantity.remark" /></td>
              </tr>
              <tr>
                <td>
                  <div>(A) NRE Amortization / Per unit (for MP)</div>
                  <div class="p-tab d-flex align-items-center">
                    <b-form-checkbox v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_check"
                                     :disabled="$attrs.readOnly"
                                     @change="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity = 0"
                                     value="Y" unchecked-value="N">NRE Amortization Quantity:</b-form-checkbox>

                    <gtc-number :read-only="$attrs.readOnly || unit_estimation_curr_stage.nre_amortization.nre_amortization_check !== 'Y'"
                                :decimalLen="0" class="ml-2 text-right min-w-6"
                                v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity" />

                  </div>
                </td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="nre_amortization_cost_hq_result" /></td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="nre_amortization_cost_gro_result" /></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>
                  <div>(B) Cost of Base unit</div>
                  <div class="p-tab d-flex align-items-center">
                    <div>Reference PN:</div>
                    <div class="ml-2">{{ unit_estimation_from_espm.cost_base_unit.remark }}</div>
                  </div>
                  <div class="p-tab d-flex align-items-center">Deduct Cost:</div>
                </td>
                <td>
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.cost_base_unit.poc_cost" />
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.deduct_cost.poc_cost" />
                </td>
                <td>
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.cost_base_unit.mp_cost" />
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.deduct_cost.mp_cost" />
                </td>
                <td>
                  <gtc-number percentage :read-only="$attrs.readOnly || !pocRequired"
                              :base="unit_estimation_from_espm.cost_base_unit.poc_cost + unit_estimation_from_espm.deduct_cost.poc_cost * -1"
                              v-model="unit_estimation_curr_stage.cost_base_unit.poc_cost" />
                </td>
                <td>
                  <gtc-number percentage :read-only="$attrs.readOnly"
                              :base="unit_estimation_from_espm.cost_base_unit.mp_cost + unit_estimation_from_espm.deduct_cost.mp_cost * -1"
                              v-model="unit_estimation_curr_stage.cost_base_unit.mp_cost" />
                </td>

                <td>
                  <div class="d-flex">
                    <span style="color: gray; font-style: italic; margin-top: 22.6px;">* Describe the deduction if have any</span>
                  </div>
                  <div class="d-flex" style="margin-top: 2px;" v-if="unit_estimation_from_espm.deduct_cost.remark === null">
                    <gtc-text-box :read-only="true" class="" v-model="nullValModel" />
                  </div>
                  <div class="d-flex" style="margin-top: 2px;" v-else>
                    <gtc-text-box :read-only="true" class="" v-model="unit_estimation_from_espm.deduct_cost.remark" />
                  </div>
                </td>

                <!--
                            <td>
                                <div class="d-flex ml-2">
                                  <gtc-text-box :read-only="true" class="" v-model="unit_estimation_from_espm.deduct_cost.remark" />
                                </div>
                              </td>
              -->

              </tr>
              <tr>
                <td>(C) Additional Material Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_material_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_material_cost.mp_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="unit_estimation_from_espm.additional_material_cost.poc_cost" v-model="unit_estimation_curr_stage.additional_material_cost.poc_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly" :base="unit_estimation_from_espm.additional_material_cost.mp_cost" v-model="unit_estimation_curr_stage.additional_material_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_curr_stage.additional_material_cost.remark" /></td>
              </tr>
              <tr>
                <td>(D) Additional MVA Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_mva_cost.mp_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="unit_estimation_from_espm.additional_mva_cost.poc_cost" v-model="unit_estimation_curr_stage.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly" :base="unit_estimation_from_espm.additional_mva_cost.mp_cost" v-model="unit_estimation_curr_stage.additional_mva_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" v-model="unit_estimation_from_espm.additional_mva_cost.remark" /></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total cost/Per unit (=A+B+C+D)</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_hq_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_hq_mp_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_gro_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_gro_mp_cost | comma }}</td>
                <td>
                  <div>GP for MP Unit: {{ $attrs.gpMpUnit }}% , GP for POC Unit: {{ $attrs.gpPocUnit }}%</div>
                  <div v-if="unit_estimation_curr_stage.nre_amortization.nre_amortization_check==='Y'">GP for MP Unit: {{ $attrs.gpMpUnitWithNreAmortizationQuantity }}% (Incl. the NRE amortization)</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region Lead-time Estimation and Notices-->
      <div class="stage-body-lead-time-estimation-and-notices border-bottom pb-4 mb-4">
        <div class="caption-label">Lead-time Estimation and Notices</div>
        <div>
          <gtc-froala :read-only="true" v-model="lead_time_notice.note_text" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region ETO Sector SKU INFO : P/N -->
      <div v-if="$attrs.isETOSELECT" class="border-bottom mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <div class="stage-body-nre-estimation border-bottom pb-4 mb-4">
              <div class="caption-label">ETO Sector SKU P/N and Limitations</div>
              <div>
                <div class="header-col">
                  <div>MPS P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="basic_info_review.eto_sector_sku.eto_select_mps_pn" />
                  </div>
                </div>
                <div class="header-col">
                  <div>SHIP P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="basic_info_review.eto_sector_sku.eto_select_ship_pn" />
                  </div>
                </div>

                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>
                    Conditions & Limitations
                  </div>
                  <div>
                    <b-form-checkbox v-model="hasRemark"
                                     name="check-button"
                                     disabled
                                     switch>
                      This ETO Sector SKU <span v-if="hasRemark"><b>has</b></span>
                      <span v-else><b>has no</b></span>
                      additional conditions and limitations
                      <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                              v-b-tooltip.hover.right
                              title="This remark will pass to eQuote, appending in the quotation line.">
                      </button>
                    </b-form-checkbox>

                  </div>
                </div>
                <div v-if="hasRemark" class="flex-fill">

                  <b-form-textarea v-if="hasRemark"
                                   id="textarea-plaintext"
                                   class="w-100"
                                   style="background: #eee;"
                                   plaintext
                                   :value=" _.get(nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', '')">
                  </b-form-textarea>
                </div>
                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>Document Link</div>
                  <div class="flex-fill">
                    <div v-if="hasDocumentLink">
                      <b-link :href="safeUrl(_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', ''))">{{_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', '')}}</b-link>
                    </div>
                    <div v-else>
                      <gtc-text-box :read-only="true"
                                    class=""
                                    v-model="nullValModel" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--#region eQuote Site and PSS Type Setting-->
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <div class="stage-body-nre-estimation">
              <div class="caption-label">eQuote Site and PSS Type</div>


              <div>
                <div class="header-col">
                  <div>eQuote Site<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <div class="row">
                      <div class="col-6">
                        <!-- $attrs.etoSectorSite  -->
                        <gtc-multi-select v-model="$attrs.etoSectorSite"
                                          key-field="value"
                                          text-field="text"
                                          :options="equoteSiteOptions"
                                          select-class="w-100" class="w-100">

                        </gtc-multi-select>
                      </div>
                      <div class="col-3">
                        <b-button variant="primary"
                                  @click="saveEquoteSite(true)">Save</b-button>

                      </div>

                    </div>

                  </div>
                </div>
                <br />
                <div class="header-col">
                  <div>PSS Type<span class="text-danger pl-1">*</span></div>
                  <div v-if="$attrs.readOnly" class="flex-fill">
                    <b-form-group>
                      <b-form-radio-group v-model="basic_info_review.eto_sector_sku.pss_type"
                                          :options="pssOptions"
                                          name="plain-inline"
                                          :disabled="$attrs.readOnly"
                                          plain>

                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                  <div v-else class="flex-fill">
                    <b-form-group>
                      <b-form-radio-group v-model="basic_info_review.eto_sector_sku.pss_type"
                                          :options="pssOptions"
                                          name="plain-inline"
                                          :disabled="$attrs.readOnly"
                                          @change="savePssType()"
                                          plain>

                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--#endregion eQuote Site and PSS Type Setting-->
      </div>
      <!--#endregion ETO Sector SKU INFO : P/N -->
      <!--#region Customize Quote Items-->
      <div class="stage-body-customize-quote-items border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div v-if="$attrs.isETOSELECT">ETO Sector SKU Quote Items (to eQuote)</div>
          <div v-else>Customize Quote Items</div>
        </div>
        <div>
          <b-table small thead-class="thead-light text-dark"
                   :items="$attrs.quoteItemsMapping" :fields="nrePage.customizeQuoteItemsSetting"
                   tbody-tr-class="position-relative">
            <template #cell(sku_id)="data">
              <div v-if="$attrs.isETOSELECT">
                {{basic_info_review.eto_sector_sku.eto_select_ship_pn}}
              </div>
              <div v-else>
                {{ data.item.sku_id }}
              </div>
            </template>
            <template #cell(qty)="data">
              {{ data.item.qty | comma(0) }}
            </template>
            <template #cell(amortize_qty)="data">
              <div v-if="['MP', 'MP Addition Cost'].includes(data.item.quote_type)" v-for="item in data.item.details">
                <div v-if="data.item.details.length > 1 || data.item.create_function !== 'ES PM'"
                     class="position-absolute px-3 text-left text-white"
                     :class="{'bg-primary': item.create_function === createFunction,
                              'bg-gray-560': item.create_function !== createFunction}"
                     style="width: 19.5rem;">
                  {{ item.create_function }}
                </div>
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.amortize_qty | comma(0) }}</div>
              </div>
            </template>
            <template #cell(hq_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.hq_cost | comma }}</div>
              </div>
            </template>
            <template #cell(gro_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.gro_cost | comma }}</div>
              </div>
            </template>
            <template #cell(action)="data">
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit" @click="$emit('quoteItemModal', data.item)"></button>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete" @click="$emit('removeQuoteItem',data.item)"></button>
            </template>
          </b-table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region GTC Sales Comments and Conclusions-->
      <div class="stage-body-gtc-sales-comments-and-conclusions">
        <div class="caption-label d-flex">
          <div>GTC Sales Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="$attrs.readOnly" v-model="nrePage.nreData.page_object.gtc_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region NEW!! Reject Reason Section-->
      <div v-if="$attrs.showReasonSection" class="stage-body-gtc-sales-comments-and-conclusions">
        <br />
        <div class="caption-label d-flex">
          <div>
            <span class="badge badge-danger" style="font-size: 16px;margin-bottom: 5px;">GTC Sales Reject Reason</span>
          </div>
        </div>
        <div v-if="nrePage.nreData.page_object.reject_reason === null">
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.gtc_comment" />
        </div>
        <div v-else>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.reject_reason" />
        </div>
      </div>
      <!--#endregion-->
    </div>
    <div class="fixed-bottom d-print-none" v-if="!$attrs.readOnly && !nrePage.isSubmitted">
      <div class="row py-3 bg-gray-150 px-4 border-top border-gray-550">
        <template v-if="!$attrs.readOnly && emptyGulidStagesMsg!==''">
          <div class="col-auto ml-auto"><img style=" display: block;margin-left: auto;margin-right: auto;" src='../../static/image/stage_icon/icon_Canceled.svg' alt="cancel"></div>
          <div style='width:60rem;font-size:0.9rem;color:red'>
            {{emptyGulidStagesMsg}}
          </div>
        </template>
        <template v-else-if="!$attrs.readOnly">
          <div class="col-auto ml-auto p-0"></div>
        </template>

        <!--
              <div class="col-auto ml-auto p-0"></div>

      -->
        <div class="col-auto">
          <button type="button" class="btn btn-success min-w-6" @click="setEquoteSiteAttribute() && $emit('save')">Save</button>
        </div>
        <div class="col-auto border-left p-0 border-gray-550" style="width:1px"></div>
        <div class="col-auto">
          <button type="button" class="btn btn-danger" @click="$emit('reject')">Reject</button>
          <button type="button" class="btn btn-primary" @click="setEquoteSiteAttribute() && validate() && $emit('submit', 'gtc_comment')">Submit to GRO</button>
          <!--
        <button v-if="autoApproveCondtion()" type="button" class="btn btn-outline-primary" @click="$emit('autoApprove')">Auto Approve</button>
        -->
        </div>
      </div>
    </div>


    <!--#endregion-->

  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    data() {
      return {
        nullValModel: 'N/A',
        pssChosen: null,
        pssOptions: [
          { text: 'ETO', value: 'ETO' },
          { text: 'STD', value: 'STD' },
        ],
        // selectedEquoteSites: null,
        /*
        equoteSiteOptions: [
          { value: 'GUSA (USD)', text: 'GUSA (USD)' },
          { value: 'WW (USD)', text: 'WW (USD)' },
          { value: 'GDE (EUR)', text: 'GDE (EUR)' },
        ],*/
         equoteSiteOptions: null,
         pssModalData: {
          nreId: null,
          field: 'pss_type',
          valToSyncNew: null,
          valToSync: null,
        }
      };
    },
    created() {
      let self = this;
      if (!self.$attrs.readOnly) {
          self.$emit('refreshQuoteItems');
      }

      if (self.emptyGulidStagesMsg !== '') {
        self.$message.warning(self.emptyGulidStagesMsg, 'Potential Error Detected');
      }
      if (self.nrePage.currency === 'GUSA(USD)') {
        self.equoteSiteOptions = [
          { value: 'GUSA (USD)', text: 'GUSA (USD)' },
        ]
      }
      if (self.nrePage.currency === 'WW (USD)') {
        self.equoteSiteOptions = [
          { value: 'WW (USD)', text: 'WW (USD)' },
          { value: 'GAU (AUD)', text: 'GAU (AUD)'},
          { value: 'EMGUS (USD)', text: 'EMGUS (USD)' },
          { value: 'EUUSD (USD)', text: 'EUUSD (USD)' },
          { value: 'LATAM (USD)', text: 'LATAM (USD)' },
          { value: 'GML (CNY)', text: 'GML (CNY)' },
        ]
      }
      if (self.nrePage.currency === 'EU (EUR)') {
        self.equoteSiteOptions = [
          { value: 'GDE (EUR)', text: 'GDE (EUR)' },
          { value: 'EMGEUR (EUR)', text: 'EMGEUR (EUR)' },
          { value: 'GIT (EUR)', text: 'GIT (EUR)' },
          { value: 'GUK (GBP)', text: 'GUK (GBP)' },
          { value: 'GUKEUR (EUR)', text: 'GUKEUR (EUR)' },
          { value: 'GFR (EUR)', text: 'GFR (EUR)' },
        ]
      }
      //console.log("self.equoteSiteOptions = ");
      //console.log(self.equoteSiteOptions);
    },
    computed: {
      hasRemark() {
        let self = this;
        if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === null
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === 'None'
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === '')
        {
          return false
        } else {
          return true
        }
      },
      hasDocumentLink() {
        let self = this;
        if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === null
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === 'None'
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === '') {
          return false
        } else {
          return true
        }
      },
      emptyGulidStagesMsg() {
        let self = this;
        let message = '';
        // all stages member have been set up, but contain 'SKIP' or Null in required stage
        let saHeadName = '';
        let hqSalesName = '';
        saHeadName = self.nrePage.nreData.page_object.basic_info_review.sign_flow_members.GRO_SA_LEADER;
        saHeadName = (_.split(saHeadName, '@')[0]).toLowerCase();

        hqSalesName = self.nrePage.nreData.page_object.basic_info_review.sign_flow_members.HQ_SALES;
        hqSalesName = (_.split(hqSalesName, '@')[0]).toLowerCase();


        //console.log(`saHeadName: ${saHeadName}`);
        //console.log(`hqSalesName: ${hqSalesName}`);

        if ('skip' === saHeadName) {
          message = `\nOne of the required stage (SA Head Review) has been set to SKIP.\nPlease contact system administrator alice.cy.lee@getac.com.tw.`;
        }
        if ('skip' === hqSalesName) {
          message = `\nOne of the required stage (HQ Sales Review) has been set to SKIP.\nPlease contact system administrator alice.cy.lee@getac.com.tw.`;
        }
        return message;
      },

      pocRequired() {
        return this.nre_estimation_from_espm.poc_required === 'Y';
      },

      canWithdraw() {
        let self = this;
        let isAwaiting = self.nrePage.nreData.espm_leader_status === 'Waiting' ||
          self.nrePage.nreData.espm_leader_status === 'W';
        return isAwaiting && self.$attrs.isSubmitted && self.$attrs.readOnly;
      },

      //#region -- Alias --

      stageNumber() {
        return this.$attrs.stageNumber;
      },
      createFunction() {
        return this.$attrs.createFunction;
      },
      skuItem() {
        return this.$attrs.skuItem;
      },
      nrePage: {
        get() {
          if (this.$attrs.isETOSelect) {
            this.pssChosen = this.$attrs.data.nreData.page_object.basic_info_review.eto_sector_sku.pss_type;
          }
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      basic_info_review: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review;
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review = value;
        }
      },
      eto_sector_to_equote_site: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list = value;
        }
      },
      nre_estimation_from_espm: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_from_espm;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_from_espm = value;
        }
      },
      proposal_files: {
        get() {
          return this.nrePage.nreData.page_object.proposal_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.proposal_files = value;
        }
      },
      reference_files: {
        get() {
          return this.nrePage.nreData.page_object.reference_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.reference_files = value;
        }
      },
      lead_time_notice: {
        get() {
          return this.nrePage.nreData.page_object.lead_time_notice;
        },
        set(value) {
          this.nrePage.nreData.page_object.lead_time_notice = value;
        }
      },
      quote_items: {
        get() {
          return this.nrePage.nreData.page_object.quote_items;
        },
        set(value) {
          this.nrePage.nreData.page_object.quote_items = value;
        }
      },
      unit_estimation_from_espm: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_from_espm;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_from_espm = value;
        }
      },
      nre_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_curr_stage = value;
        }
      },
      unit_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_curr_stage = value;
        }
      },
      //#endregion
      //#region -- Price --

      laborCost() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_from_espm.labor_cost, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_from_espm.labor_cost, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },
      jobCost() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_from_espm.job_cost, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_from_espm.job_cost, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },
      regulation() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_from_espm.regulation, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_from_espm.regulation, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },
      nre_estimation_total_poc_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_from_espm.labor_cost.development.poc_cost,
          self.nre_estimation_from_espm.labor_cost.verification.poc_cost,
          self.nre_estimation_from_espm.test_sample.poc_cost,
          self.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.test_jig.poc_cost,
          self.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost,
          self.nre_estimation_from_espm.regulation.emc.poc_cost,
          self.nre_estimation_from_espm.regulation.safety.poc_cost,
          self.nre_estimation_from_espm.regulation.environment.poc_cost,
          self.nre_estimation_from_espm.regulation.regulation_others.poc_cost,
          self.nre_estimation_from_espm.others.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_from_espm.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_from_espm.labor_cost.development.mp_cost,
          self.nre_estimation_from_espm.labor_cost.verification.mp_cost,
          self.nre_estimation_from_espm.test_sample.mp_cost,
          self.nre_estimation_from_espm.job_cost.tooling_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.pcb_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.test_jig.mp_cost,
          self.nre_estimation_from_espm.job_cost.outsource_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.job_cost_others.mp_cost,
          self.nre_estimation_from_espm.regulation.emc.mp_cost,
          self.nre_estimation_from_espm.regulation.safety.mp_cost,
          self.nre_estimation_from_espm.regulation.environment.mp_cost,
          self.nre_estimation_from_espm.regulation.regulation_others.mp_cost,
          self.nre_estimation_from_espm.others.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_from_espm.total_cost.mp_cost = result;
        return result;
      },

      nre_estimation_total_poc_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.poc_cost,
          self.nre_estimation_curr_stage.test_sample.poc_cost,
          self.nre_estimation_curr_stage.job_cost.poc_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.poc_cost,
          self.nre_estimation_curr_stage.others.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.mp_cost,
          self.nre_estimation_curr_stage.test_sample.mp_cost,
          self.nre_estimation_curr_stage.job_cost.mp_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.mp_cost,
          self.nre_estimation_curr_stage.others.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },

      nre_amortization_cost_hq_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost;
        let amortization_quantity = self.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_curr_stage.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_from_espm.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      nre_amortization_cost_gro_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost_curr_stage;
        let amortization_quantity = self.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_curr_stage.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      unit_estimation_total_hq_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_from_espm.cost_base_unit.poc_cost,
          self.unit_estimation_from_espm.additional_material_cost.poc_cost,
          self.unit_estimation_from_espm.additional_mva_cost.poc_cost,
          self.unit_estimation_from_espm.deduct_cost.poc_cost * -1
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_from_espm.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_hq_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_from_espm.nre_amortization.nre_amortization_cost,
          self.unit_estimation_from_espm.cost_base_unit.mp_cost,
          self.unit_estimation_from_espm.additional_material_cost.mp_cost,
          self.unit_estimation_from_espm.additional_mva_cost.mp_cost,
          self.unit_estimation_from_espm.deduct_cost.mp_cost * -1
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_from_espm.total_cost.mp_cost = result;
        return result;
      },
      unit_estimation_total_gro_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.cost_base_unit.poc_cost,
          self.unit_estimation_curr_stage.additional_material_cost.poc_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_gro_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost,
          self.unit_estimation_curr_stage.cost_base_unit.mp_cost,
          self.unit_estimation_curr_stage.additional_material_cost.mp_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },
      //#endregion
    },
    methods: {
      setEquoteSiteAttribute() {
        let self = this;
        if (!self.$attrs.isETOSELECT) {
          return true;
        }
        var i;
        var siteSelected = [];
        //console.log(self.$attrs.etoSectorSite);
        if (self.$attrs.etoSectorSite !== null && self.$attrs.etoSectorSite.length > 0) {
          for (i = 0; i < self.$attrs.etoSectorSite.length; i++) {
            siteSelected.push(self.$attrs.etoSectorSite[i]['value'])
          }
        }
        _.set(self.nrePage.nreData.page_object.basic_info_review.eto_sector_sku, 'equote_site_selected_list', siteSelected);
        return true;
      },
      saveEquoteSite(loading) {
        let self = this;
        var i;
        var siteSelected = [];
        //console.log(self.selectedEquoteSites);
        //console.log(self.$attrs.etoSectorSite);
        if (self.$attrs.etoSectorSite.length > 0) {
          for (i = 0; i < self.$attrs.etoSectorSite.length; i++) {
            siteSelected.push(self.$attrs.etoSectorSite[i]['value'])
          }
        }
        let requestData = {
          ftie_id: self.basic_info_review.ftie_id,
          nre_id: self.basic_info_review.nre_id,
          create_by: this.$session.get('user_name'),
          username: this.$session.get('user_name'),
          edit_field: 'equote_site',
          input_info: siteSelected
        };
        if (loading) {
          eventHub.$emit('loading', true);
        }

        self.$axios
          .post(self.$root.baseUrl + '/eto-sector-sku/update/', requestData)
          .then(res => {
            let result = res.data;
            console.log("updateETOSectorSku:result");
            //console.log(result);
            let result_obj = null;
            if (res.status === 200) {
              result.save_success = JSON.parse(result.save_success);
              result_obj = result.save_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            if (loading) {
              self.$emit('reload');
              eventHub.$emit('loading', false);
            }
          });
      },
      savePssType() {
        let self = this;
        self.pssChosen = self.basic_info_review.eto_sector_sku.pss_type
        //console.log("pssChosen=");
        //console.log(self.pssChosen);
        _.set(self.pssModalData, 'nreId', self.basic_info_review.nre_id);
        _.set(self.pssModalData, 'valToSyncNew', self.pssChosen);
        _.set(self.pssModalData, 'valToSync', self.basic_info_review.eto_sector_sku.pss_type);

        let requestData = {
          ftie_id: self.basic_info_review.ftie_id,
          nre_id: self.basic_info_review.nre_id,
          create_by: this.$session.get('user_name'),
          username: this.$session.get('user_name'),
          edit_field: 'pss_type',
          input_info: self.pssModalData
        };
        eventHub.$emit('loading', true);
        self.$axios
          .post(self.$root.baseUrl + '/eto-sector-sku/update/', requestData)
          .then(res => {
            let result = res.data;
            console.log("updateETOSectorSku:result");
            //console.log(result);
            let result_obj = null;
            if (res.status === 200) {
              result.save_success = JSON.parse(result.save_success);
              result_obj = result.save_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {

            // reload
            // self.reloadEtoSectorSku();
            eventHub.$emit('loading', false);
          });
      },
      validate() {
        let self = this;

        let div = document.createElement('div');
        div.innerHTML = self.lead_time_notice.note_text;

        let items = _.filter($(div).find('span[style*="background-color: #fac51c;"]'), item => {
          return item.innerHTML === '__';
        });
        //console.log(items.length);

        let fieldNames = _.map(items, item => { return $(item).attr('data-field'); });

        if (self.$attrs.isETOSELECT && self.basic_info_review.eto_sector_sku.pss_type === null) {
          self.$message.warning('\nPlease choose the PSS type!', 'PSS Type Missing');
          return false;
        }
        if (self.$attrs.isETOSELECT
          && (self.nrePage.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list === null || self.nrePage.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list.length === 0)) {
          self.$message.warning('\nPlease choose at least one site that will display this ETO Sector SKU Quote in eQuote!', 'eQuote Site Missing');
          return false;
        }

        if (self.quote_items.length < 1) {
          self.$message.warning('\nSystem detect some potential errors in quote item. \nPlease contact the system administrator alice.cy.lee@getac.com.tw.', 'Potential Error Detected');

          return false;
        }

        if (self.emptyGulidStagesMsg !== '') {
          self.$message.warning('\nSystem detect some potential errors in sign flow, which might effect the ETO process. \nPlease contact the system administrator alice.cy.lee@getac.com.tw.', 'Potential Error Detected');
          return false;
        }

        return true;
      },

      autoApproveCondtion() {
        // Return True or False
        /*
         * 1. GUSA
         * 2. Total NRE == 0
         * 3. Additional Material Cost / Per unit + Additional MVA Cost / Per unit == 0
         * 4. Ref sku selling price
         * */
        let self = this;

        if ('GUSA' !== self.basic_info_review.region) {
          return false;
        }

        let additional_cost_per_unit_espm = self.unit_estimation_from_espm.additional_material_cost.mp_cost + self.unit_estimation_from_espm.additional_mva_cost.mp_cost;
        let additional_cost_per_unit_curr = self.unit_estimation_curr_stage.additional_material_cost.mp_cost + self.unit_estimation_curr_stage.additional_mva_cost.mp_cost;
        let total_nre_mp_espm = self.nre_estimation_total_mp_cost;
        let total_nre_poc_espm = self.nre_estimation_total_poc_cost;
        let total_nre_mp_curr = self.nre_estimation_total_mp_cost_curr_stage;
        let total_nre_poc_curr = self.nre_estimation_total_poc_cost_curr_stage;

        if (total_nre_mp_espm + total_nre_poc_espm + total_nre_mp_curr + total_nre_poc_curr > 0) {
          return false;
        }


        if (additional_cost_per_unit_espm + additional_cost_per_unit_curr > 0) {
          return false;
        }

        if (self.skuItem === null || _.get(self.skuItem, 'price_info.cost_empty', '') === true || _.get(self.skuItem, 'price_info.reseller_price', '') === '') {
          return false;
        }

        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HQSalesReview.vue